const createEntity = (key, { type, mutability, data }) => {
  return { [key.toString()]: { type, mutability, data } };
};
export {
  createEntity
};
//# sourceMappingURL=create-entity.js.map
